export const isAppLoaded = (state) => state.isAppLoaded

export const languages = (state) => state.languages

export const currencies = (state) => state.currencies

export const timeZones = (state) => state.timeZones

export const dateFormats = (state) => state.dateFormats

export const fiscalYears = (state) => state.fiscalYears

export const countries = (state) => state.countries

export const isSidebarOpen = (state) => state.isSidebarOpen
